import { useEffect, useState } from 'react';
import { findCourse } from './infra/repository/FindCourse';

export const INITIAL_COURSE_ID = 'learnfrench';

export function useCourse(courseId) {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let active = true;
    setState({ courseId, loading: true });
    findCourse(courseId).then(
      course => { if (active) setState({ courseId, course, loading: false }); },
      error => { if (active) setState({ courseId, loading: false, error: error.response?.status === 404
        ? 'Course not found.' : 'Unable to load this course. Please try again.' }); }
    );
    return () => { active = false; };
  }, [courseId]);
  return state.courseId === courseId ? state : { loading: true };
}
